/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const launch_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.143 4H4v16h16v-5.143m-7.429-3.428L20 4m0 0h-5.714M20 4v5.714"
    />
  </svg>
)
export default launch_medium
